import type { EnhancedStore } from '@reduxjs/toolkit';
import axios from 'axios';

import { captureSentryError } from '../utils';

import { fetchResourceFailure } from './actions';

export async function withErrorHandling(store: EnhancedStore, func: () => any) {
  const { dispatch } = store;
  try {
    return await func();
  } catch (error: any) {
    // deliver the most useful error report to Sentry based on XHR result
    if (axios.isCancel(error)) {
      // do nothing
    } else if (error.response) {
      let errorMessage = error;
      const response = error.response;
      const pharmakonErrors = response?.data?.errors ?? [];

      if (pharmakonErrors && pharmakonErrors.length >= 1) {
        const reason = pharmakonErrors[0]?.detail;
        errorMessage = `${reason}  [${response.status} ${response.statusText}]`;
      }

      captureSentryError(errorMessage, { state: store.getState(), error, fingerprint: ['api', errorMessage] });
    } else {
      captureSentryError(`Error: ${error.message}`, {
        state: store.getState(),
        error,
        fingerprint: ['api', error.message],
      });
    }

    dispatch(fetchResourceFailure(error));

    throw error;
  }
}
